import { CardConfig } from '../components/SettingsMenu';

export const DEFAULT_CARD_CONFIGS: CardConfig[] = [
  {
    id: 'map',
    name: 'Map',
    description: 'Interactive map for selecting train zones',
    enabled: true,
  },
  {
    id: 'models',
    name: 'Models Selection',
    description: 'Weather model configuration and selection',
    enabled: true,
  },
  {
    id: 'chart',
    name: 'Forecast Chart',
    description: 'Interactive chart displaying selected parameter and deltas',
    enabled: true,
    type: 'chart',
  },
  {
    id: 'heatmap',
    name: 'Heatmap',
    description: 'Heatmap showing model agreement and disagreements',
    enabled: true,
  },
];
